import { render } from "./CreateAdjustmentsPage.vue?vue&type=template&id=41effc48&ts=true"
import script from "./CreateAdjustmentsPage.vue?vue&type=script&lang=ts"
export * from "./CreateAdjustmentsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__